<!-- Use este arquivo como base para novos módulos de CRUD, -->
<!-- apenas copiando ele e colando na pasta respectiva -->

<template>
  <crud-base
    :url="url"
    :columns="columns"
    :onDelete="() => {}"
    :onUpdate="() => {}"
    :onStore="() => {}"
    :enableSearch="true"
    :formInputs="formInputs"
    :checkAlerts="true"
    primaryKey="id"
  />
</template>

<script>
import CrudBase from "../../../components/crud/CrudBase";
import {
  schemaBoolean,
  schemaSqlEditor,
  schemaTextArea,
  schemaTextField
} from "@/helpers/form";
import {yesNoRepresentation} from "@/helpers/transformers";
export default {
  name: "crud-template",
  components: {
    CrudBase,
  },
  data() {
    return {
      url: "/admin/condicoes/operacao-cobranca",
      columns: [
        {
          label: "ID",
          field: "id",
          sortable: false
        },
        {
          label: "Operação",
          field: "operacao",
          sortable: false,
          representedAs : (row) => !!(row?.operacao)
              ? `${row.operacao_id} - ${row.operacao.descricao}`
              : row.operacao_id
        },
        {
          label: "Cobrança",
          field: "cobranca",
          sortable: false,
          representedAs : (row) => !!(row?.cobranca)
              ? `${row.cobranca_id} - ${row.cobranca.descricao}`
              : row.cobranca_id
        },
        {
          label: "Ativo",
          field: "ativo",
          sortable: false,
          representedAs: (row) => yesNoRepresentation(row.ativo)
        }
      ],
    };
  },
};
</script>
